import type { WidgetDefinition } from '../WidgetDefinition';
import { faListTimeline } from '@fortawesome/pro-regular-svg-icons/faListTimeline';
import type { PositionsWidgetModel } from '@thinkalpha/ui-types/contracts/workspace';
import { parseInstrument } from 'src/lib/instrumentUtils';
import type { PositionsWidgetViewModel } from 'src/store/types';

class PositionsWidgetDefinition implements WidgetDefinition<PositionsWidgetViewModel, PositionsWidgetModel> {
    type = 'positions' as const;
    nameKey = 'widgets::positions::name' as const;
    roles = ['widgets::positions'];
    icon = faListTimeline;
    category = 'widgets::categories::risk' as const;

    /**
     * Converts a Positions widget from contract model to view model
     */
    toViewModel(widget: PositionsWidgetModel): PositionsWidgetViewModel {
        return {
            ...widget,
            instrument: parseInstrument(''),
            type: 'positions',
        };
    }

    /**
     * Converts a Positions widget from view model to contract model
     */
    toContractModel(widget: PositionsWidgetViewModel): PositionsWidgetModel {
        const { instrument: _instrument, ...contractWidget } = widget;
        return contractWidget;
    }
}

export const positionsWidgetDefinition = new PositionsWidgetDefinition();
